import type { LeaseActionProps } from '../../../models/Types';
import DeactivateLeaseConfirmationModal from '../../DeactivateLeaseConfirmationModal';

export default function OpenModalDeactivateLeaseConfirmation(props: LeaseActionProps) {
  return <DeactivateLeaseConfirmationModal onClose={props.terminateActiveAction} lease={props.lease} />;
}
